import { useState } from "react";
import { DCUIThemingTabTypes } from "@enums/dcui-theming-tab-types";
import { LabelWidthTypes } from "@enums/label-width-types";
import { DCUIThemingPreviewConfigurationState } from "@idw-types/common/dcui/dcui-theming-preview-configuration-state";
import { ToggleFormGroup } from "../../toggle-form-group/toggle-form-group";
import styles from "./dcui-theming-preview-configuration-container.less";

type DCUIThemingPreviewConfigurationContainerProps = {
    currentTab: DCUIThemingTabTypes;
    previewConfigurationState: DCUIThemingPreviewConfigurationState;
    setPreviewConfigurationState: (previewConfigurationState: DCUIThemingPreviewConfigurationState) => void;
};

export const DCUIThemingPreviewConfigurationContainer = (props: DCUIThemingPreviewConfigurationContainerProps) => {
    const { currentTab, previewConfigurationState, setPreviewConfigurationState } = props;

    const [labelWidth] = useState(LabelWidthTypes.EXTRA_SMALL);

    const handleShowStartPageInProgressChange = () => {
        setPreviewConfigurationState({
            ...previewConfigurationState,
            showStartPageInProgress: !previewConfigurationState.showStartPageInProgress
        });
    };

    const handleShowCompletePageUploadInProgressChange = () => {
        setPreviewConfigurationState({
            ...previewConfigurationState,
            showCompletePageUploadInProgress: !previewConfigurationState.showCompletePageUploadInProgress,
            showCompletePageRedirectMessage: false,
            showCompletePageUploadErrorMessage: false
        });
    };

    const handleShowCompletePageRedirectMessageChange = () => {
        setPreviewConfigurationState({
            ...previewConfigurationState,
            showCompletePageRedirectMessage: !previewConfigurationState.showCompletePageRedirectMessage,
            showCompletePageUploadInProgress: false,
            showCompletePageUploadErrorMessage: false
        });
    };

    const handleShowCompletePageUploadErrorMessageChange = () => {
        setPreviewConfigurationState({
            ...previewConfigurationState,
            showCompletePageUploadErrorMessage: !previewConfigurationState.showCompletePageUploadErrorMessage,
            showCompletePageRedirectMessage: false,
            showCompletePageUploadInProgress: false
        });
    };

    return (
        <div className={styles.dcuiThemingPreviewConfigurationContainer}>
            {currentTab === DCUIThemingTabTypes.START_PAGE && (
                <>
                    <span className={styles.previewConfigurationTitle}>Preview Configuration - Start Page</span>
                    <div className={styles.toggleContainer}>
                        <ToggleFormGroup
                            controlId={"show-start-page-in-progress-toggle"}
                            automationId={"show-start-page-in-progress-toggle"}
                            label={"Show 'In Progress' State"}
                            ariaLabel={"Show 'In Progress' State"}
                            checkedIcon={false}
                            uncheckedIcon={false}
                            labelWidth={labelWidth}
                            checked={previewConfigurationState.showStartPageInProgress}
                            disabled={false}
                            isRequired={false}
                            onChange={handleShowStartPageInProgressChange}
                            value={`${previewConfigurationState.showStartPageInProgress}`}
                        />
                    </div>
                </>
            )}
            {currentTab === DCUIThemingTabTypes.CAPTURE_COMPLETE && (
                <>
                    <span className={styles.previewConfigurationTitle}>Preview Configuration - Complete Page</span>
                    <div className={styles.toggleContainer}>
                        <ToggleFormGroup
                            controlId={"show-complete-page-upload-in-progress-toggle"}
                            automationId={"show-complete-page-upload-in-progress-toggle"}
                            label={"Show 'Upload In Progress' State"}
                            ariaLabel={"Show 'Upload In Progress' State"}
                            checkedIcon={false}
                            uncheckedIcon={false}
                            labelWidth={labelWidth}
                            checked={previewConfigurationState.showCompletePageUploadInProgress}
                            disabled={false}
                            isRequired={false}
                            onChange={handleShowCompletePageUploadInProgressChange}
                            value={`${previewConfigurationState.showCompletePageUploadInProgress}`}
                        />
                    </div>
                    <div className={styles.toggleContainer}>
                        <ToggleFormGroup
                            controlId={"show-complete-page-redirect-message-toggle"}
                            automationId={"show-complete-page-redirect-message-toggle"}
                            label={"Show 'With Redirect' State"}
                            ariaLabel={"Show 'With Redirect' State"}
                            checkedIcon={false}
                            uncheckedIcon={false}
                            labelWidth={labelWidth}
                            checked={previewConfigurationState.showCompletePageRedirectMessage}
                            disabled={false}
                            isRequired={false}
                            onChange={handleShowCompletePageRedirectMessageChange}
                            value={`${previewConfigurationState.showCompletePageRedirectMessage}`}
                        />
                    </div>
                    <div className={styles.toggleContainer}>
                        <ToggleFormGroup
                            controlId={"show-complete-page-upload-error-message-toggle"}
                            automationId={"show-complete-page-upload-error-message-toggle"}
                            label={"Show 'Upload Error' State"}
                            ariaLabel={"Show 'Upload Error' State"}
                            checkedIcon={false}
                            uncheckedIcon={false}
                            labelWidth={labelWidth}
                            checked={previewConfigurationState.showCompletePageUploadErrorMessage}
                            disabled={false}
                            isRequired={false}
                            onChange={handleShowCompletePageUploadErrorMessageChange}
                            value={`${previewConfigurationState.showCompletePageUploadErrorMessage}`}
                        />
                    </div>
                </>
            )}
        </div>
    );
};